/**
 * Bookings query hook
 * Fetches all bookings with realtime subscription
 */

import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Booking } from "@/types/admin/booking";
import { useBookingsRealtime } from "./useBookingsRealtime";

/**
 * Hook to fetch all bookings with realtime updates
 */
export const useBookings = () => {
  useBookingsRealtime();
  
  return useQuery({
    queryKey: ["bookings"],
    queryFn: async (): Promise<Booking[]> => {
      const { data: bookings, error } = await supabase
        .from("bookings")
        .select(
          `
          *,
          origins (
            name
          )
        `,
        )
        .order("created_at", { ascending: false });

      if (error) {
        throw error;
      }

      return (bookings || []).map((booking) => ({
        ...booking,
        status: booking.status as "Reservada" | "Cancelada",
      }));
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
